import {
  getProductImage,
  type ImageSize,
  type ImageTypeName,
} from '@sofa-platform/dexf-utils/src/utils/get-product-image'
import type { ProductData } from '@sofa-platform/types/src/types'

import type { EventName, SendOptions } from '@/hooks/use-insights'

export function getProductImageOrFallbackProductAltText(
  productData: ProductData,
  size: ImageSize,
  typeName: ImageTypeName,
  sendCustomEvent: <K extends EventName>(name: K, options?: SendOptions<K>) => void,
) {
  const img = getProductImage(productData, size, typeName)
  return { alt: img?.alt ?? getFallbackProductAltText(productData, sendCustomEvent), src: img?.src }
}

function getFallbackProductAltText(
  productData: ProductData,
  sendCustomEvent: <K extends EventName>(name: K, options?: SendOptions<K>) => void,
) {
  sendCustomEvent('no_alt_text_for_product_image', {
    payload: {
      itemId: productData.itemId,
    },
  })
  return `${productData.content.name} ${productData.content.typeName} ${productData.content.validDesignText}`
}
